import type { ResultsSearchStatsField } from "@app/types/urgency-banners";

export const getResultSearchCount = (
  outbound_search_date: string | null,
  result_search_stats: ResultsSearchStatsField[] | null
) => {
  if (
    !result_search_stats ||
    !outbound_search_date ||
    result_search_stats.length === 0
  ) {
    return null;
  }

  return (
    result_search_stats.find(
      data => data.outbound_date === outbound_search_date
    )?.search_count || null
  );
};
